import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatSecondsToMinutes',
  standalone: true,
})
export class FormatSecondsToMinutesPipe implements PipeTransform {
  transform(seconds: number): string {
    if (!Number.isFinite(seconds)) return '0:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  }
}
